import { useSelector } from "react-redux";
import ProductItem from "../productItem/productItem";

const ProductItemsList = ({ categoryIndex, subCategoryIndex }) => {

    const products = useSelector((state) => state.featuredProducts.categories[categoryIndex].subCategories[subCategoryIndex].productsList);

    return (
        <>
            {products && products.map((product, index) => {
                var img = `${process.env.REACT_APP_URL}/static/images/sample-img.jpg`;
                if (product.images.length != 0) {
                    img = `${process.env.REACT_APP_SERVER_URL}/images/${product.images[0]}`;
                }
                if (index < 8) {
                    return (
                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-6 my-2" key={index}>
                            <ProductItem id={product._id} path={img} title={product.title} location={product.location} price={parseFloat(product.buyNowPrice).toFixed(2)} />
                        </div>
                    );
                }
            })}
        </>
    );
}

export default ProductItemsList;